import {
  Category,
  FinancialPublication,
  Localization,
  Thematic,
  InvestorsThematic,
} from '@lglp/prismic-client';
import { __, prop } from 'ramda';

import {
  CATEGORIES as TRANS_CATEGORY,
  EXPERTISES as TRANS_EXPERTISE,
  PUBLICATION as TRANS_PUBLICATION,
  TERRITORIES as TRANS_REGION,
  THEMATICS as TRANS_THEMATIC,
  TYPES as TRANS_MEDIA_TYPE,
} from 'translations';

import {
  CLASSIFICATION as TYPE_CLASSIFICATION,
  EXPERTISE as TYPE_EXPERTISE,
  PUBLICATION as TYPE_PUBLICATION,
} from '../types/filters';
import { MEDIA_TYPE } from '../types/press-media';

// Expertise

export const TYPE_TO_TRANSLATION_EXPERTISE = {
  [TYPE_EXPERTISE.AUDIOVISUAL]: TRANS_EXPERTISE.AUDIOVISUAL,
  [TYPE_EXPERTISE.BANK_INSURANCE]: TRANS_EXPERTISE.BANK_INSURANCE,
  [TYPE_EXPERTISE.COURRIER]: TRANS_EXPERTISE.COURRIER,
  [TYPE_EXPERTISE.DIGITAL]: TRANS_EXPERTISE.DIGITAL,
  [TYPE_EXPERTISE.TRANSVERSE]: TRANS_EXPERTISE.DIRECTION,
  [TYPE_EXPERTISE.ENERGY]: TRANS_EXPERTISE.ENERGY,
  [TYPE_EXPERTISE.HUMAN_RESOURCES]: TRANS_EXPERTISE.HUMAN_RESOURCES,
  [TYPE_EXPERTISE.INTERNATIONAL]: TRANS_EXPERTISE.INTL,
  [TYPE_EXPERTISE.MOBILE]: TRANS_EXPERTISE.MOBILE,
  [TYPE_EXPERTISE.PARTNERS]: TRANS_EXPERTISE.PARTNERS,
  [TYPE_EXPERTISE.URBAN]: TRANS_EXPERTISE.URBAN,
};

export const translateExpertise = prop(__, TYPE_TO_TRANSLATION_EXPERTISE);

// Thematic

export const TYPE_TO_TRANSLATION_THEMATIC = {
  [Thematic.Bank]: TRANS_THEMATIC.BANK,
  [Thematic.LetterPackage]: TRANS_THEMATIC.LETTER_PACKAGE,
  [Thematic.Dt]: TRANS_THEMATIC.DT,
  [Thematic.InformationsFinancieres]: TRANS_THEMATIC.INFORMATIONS_FINANCIERES,
  [Thematic.Innovation]: TRANS_THEMATIC.INNOVATION,
  [Thematic.Group]: TRANS_THEMATIC.GROUPE,
  [Thematic.Logistic]: TRANS_THEMATIC.LOGISTIC,
  [Thematic.Medias]: TRANS_THEMATIC.MEDIA,
  [Thematic.Partnership]: TRANS_THEMATIC.PARTNERSHIP,
  [Thematic.HumanResource]: TRANS_THEMATIC.HUMAN_RESOURCES,
  [Thematic.Culture]: TRANS_THEMATIC.CULTURE,
  [Thematic.NouveauxServices]: TRANS_THEMATIC.NOUVEAUX_SERVICES,
  [Thematic.Numerique]: TRANS_THEMATIC.NUMERIQUE,
  [Thematic.Ecology]: TRANS_THEMATIC.ECOLOGY,
  [Thematic.Philately]: TRANS_THEMATIC.PHILATELY,
};

export const translateThematic = prop(__, TYPE_TO_TRANSLATION_THEMATIC);

// Thematic

export const TYPE_TO_TRANSLATION_INVESTORS_THEMATIC = {
  [InvestorsThematic.Results]: 'FILTERS_INVESTORS_THEMATICS_RESULTS',
  [InvestorsThematic.Acquisitions]: 'FILTERS_INVESTORS_THEMATICS_ACQUISITIONS',
  [InvestorsThematic.Strategy]: 'FILTERS_INVESTORS_THEMATICS_STRATEGY',
  [InvestorsThematic.Governance]: 'FILTERS_INVESTORS_THEMATICS_GOVERNANCE',
  [InvestorsThematic.Emissions]: 'FILTERS_INVESTORS_THEMATICS_EMISSIONS',
  [InvestorsThematic.BSCC]: 'FILTERS_INVESTORS_THEMATICS_BSCC',
  [InvestorsThematic.GEOPOST]: 'FILTERS_INVESTORS_THEMATICS_GEOPOST',
  [InvestorsThematic.LBP]: 'FILTERS_INVESTORS_THEMATICS_LBP',
  [InvestorsThematic.CNP]: 'FILTERS_INVESTORS_THEMATICS_CNP',
  [InvestorsThematic.BGPN]: 'FILTERS_INVESTORS_THEMATICS_BGPN',
  [InvestorsThematic.Other]: 'FILTERS_INVESTORS_THEMATICS_OTHER',
};

export const translateInvestorsThematic = prop(
  __,
  TYPE_TO_TRANSLATION_INVESTORS_THEMATIC
);

// Category

export const TYPE_TO_TRANSLATION_CATEGORY = {
  [Category.Case]: TRANS_CATEGORY.WIDE_ANGLE,
  [Category.Event]: TRANS_CATEGORY.EVENT,
  [Category.Focus]: TRANS_CATEGORY.START_UP,
  [Category.InnerPage]: TRANS_CATEGORY.INNER_PAGE,
  [Category.Interview]: TRANS_CATEGORY.PODCAST,
  [Category.KeysFigures]: TRANS_CATEGORY.MARKS,
  [Category.Lifespiration]: TRANS_CATEGORY.LIFESPIRATION,
  [Category.Misconception]: TRANS_CATEGORY.MISCONCEPTION,
  [Category.PointOfView]: TRANS_CATEGORY.LIGHTING,
  [Category.Portrait]: TRANS_CATEGORY.MEETING,
  [Category.Services]: TRANS_CATEGORY.INNOVATION,
  [Category.Publication]: TRANS_CATEGORY.PUBLICATION,
  [Category.PublicationDownloadable]: TRANS_CATEGORY.PUBLICATION_DOWNLOADABLE,
  [Category.RightNow]: TRANS_CATEGORY.STANDBY,
};

export const translateCategory = prop(__, TYPE_TO_TRANSLATION_CATEGORY);

// MediaTypes

export const TYPE_TO_TRANSLATION_MEDIA = {
  [MEDIA_TYPE.PUBLICATION]: TRANS_MEDIA_TYPE.PUBLICATIONS,
  [MEDIA_TYPE.RELEASE]: TRANS_MEDIA_TYPE.RELEASES,
};

export const translateMediaType = prop(__, TYPE_TO_TRANSLATION_MEDIA);

// Region

export const TYPE_TO_TRANSLATION_REGION = {
  [Localization.AUVERGNE]: TRANS_REGION.AUVERGNE,
  [Localization.BOURGOGNE]: TRANS_REGION.BOURGOGNE,
  [Localization.BRETAGNE]: TRANS_REGION.BRETAGNE,
  [Localization.CENTRE]: TRANS_REGION.CENTRE_VAL_DE_LOIRE,
  [Localization.CORSE]: TRANS_REGION.CORSE,
  [Localization.DOM]: TRANS_REGION.DOM,
  [Localization.GRAND_EST]: TRANS_REGION.GRAND_EST,
  [Localization.HAUTS_DE_FRANCE]: TRANS_REGION.HAUTS_DE_FRANCE,
  [Localization.ILE_DE_FRANCE]: TRANS_REGION.ILE_DE_FRANCE,
  [Localization.NOUVELLE_AQUITAINE]: TRANS_REGION.NOUVELLE_AQUITAINE,
  [Localization.NORMANDIE]: TRANS_REGION.NORMANDIE,
  [Localization.OCCITANIE]: TRANS_REGION.OCCITANIE,
  [Localization.PAYS_DE_LA_LOIRE]: TRANS_REGION.PAYS_DE_LA_LOIRE,
  [Localization.PACA]: TRANS_REGION.PACA,
  [Localization.AFRIQUE]: TRANS_REGION.AFRIQUE,
  [Localization.AMERIQUE]: TRANS_REGION.AMERIQUE,
  [Localization.ASIE]: TRANS_REGION.ASIE,
  [Localization.EUROPE]: TRANS_REGION.EUROPE,
  [Localization.OCEANIE]: TRANS_REGION.OCEANIE,
  [Localization.National]: TRANS_REGION.NATIONAL,
  [Localization.International]: TRANS_REGION.INTERNATIONAL,
};

export const translateRegion = prop(__, TYPE_TO_TRANSLATION_REGION);

// Classification

export const MAPPING_CLASSIFICATION = {
  [TYPE_CLASSIFICATION.EVENTS]: TRANS_MEDIA_TYPE.EVENTS,
  [TYPE_CLASSIFICATION.PUBLICATION]: TRANS_MEDIA_TYPE.PUBLICATIONS,
  [TYPE_CLASSIFICATION.NEWS]: TRANS_MEDIA_TYPE.NEWS,
  [TYPE_CLASSIFICATION.INNOVATION]: TRANS_MEDIA_TYPE.INNOVATIONS,
  [TYPE_CLASSIFICATION.STARTUP]: TRANS_MEDIA_TYPE.STARTUP,
};

export const translateClassification = prop(__, MAPPING_CLASSIFICATION);

// Common thematic

export const TYPE_TO_TRANSLATION_COMMON_THEMATIC = {
  ...TYPE_TO_TRANSLATION_THEMATIC,
  ...TYPE_TO_TRANSLATION_EXPERTISE,
};

export const translateCommonThematic = prop(
  __,
  TYPE_TO_TRANSLATION_COMMON_THEMATIC
);

// Publications

export const TYPE_TO_TRANSLATION_PUBLICATION = {
  [TYPE_PUBLICATION.ACTIVITY_REPORT]: TRANS_PUBLICATION.PUB_ACTIVITY_REPORT,
  [TYPE_PUBLICATION.SOCIAL_REPORT]: TRANS_PUBLICATION.PUB_SOCIAL_REPORT,
  [TYPE_PUBLICATION.THEME_MEMENTO]: TRANS_PUBLICATION.PUB_THEME_MEMENTO,
  [TYPE_PUBLICATION.STUDY_BAROMETRE]: TRANS_PUBLICATION.PUB_STUDY_BAROMETRE,
  [TYPE_PUBLICATION.WHITE_PAPER]: TRANS_PUBLICATION.PUB_WHITE_PAPER,
  [TYPE_PUBLICATION.POSTEO_BOOK]: TRANS_PUBLICATION.PUB_POSTEO_BOOK,
  [TYPE_PUBLICATION.POSTEO_MAGAZINE]: TRANS_PUBLICATION.PUB_POSTEO_MAGAZINE,
};

export const translatePublication = prop(__, TYPE_TO_TRANSLATION_PUBLICATION);

// Financial publications

export const TYPE_TO_TRANSLATION_FINANCIAL_PUBLICATION = {
  [FinancialPublication.FullYearResult]:
    TRANS_PUBLICATION.PUB_FULL_YEAR_RESULTS,
  [FinancialPublication.GreendBond]: TRANS_PUBLICATION.PUB_GREEN_BOND,
  [FinancialPublication.HalfResult]: TRANS_PUBLICATION.PUB_HALF_RESULTS,
  [FinancialPublication.InvestorPresentations]:
    TRANS_PUBLICATION.PUB_INVESTOR_PRESENTATIONS,
  [FinancialPublication.ReferenceDocument]:
    TRANS_PUBLICATION.PUB_REFERENCE_DOCUMENT,
  [FinancialPublication.RseReport]: TRANS_PUBLICATION.PUB_RSE_REPORT,
  [FinancialPublication.Urd]:
    TRANS_PUBLICATION.PUB_UNIVESAL_REGISTRATION_DOCUMENT,
  [FinancialPublication.EnterpriseGovernmentReport]:
    TRANS_PUBLICATION.PUB_ENTERPRISE_GOVERNMENT_REPORT,
  [FinancialPublication.VotingRightNbActions]:
    TRANS_PUBLICATION.PUB_VOTING_RIGHT_NB_ACTIONS,
};

export const translateFinancialPublication = prop(
  __,
  TYPE_TO_TRANSLATION_FINANCIAL_PUBLICATION
);
